import { classNames } from '@utils/classNames';

type BadgeProps = {
  text: string;
  isActive?: boolean;
  className?: string;
};

export const Badge = ({ text, isActive = false, className }: BadgeProps) => {
  return (
    <div
      className={classNames(
        'px-4 py-1 rounded-full text-sm text-nowrap',
        isActive ? 'bg-grey1 text-white' : 'bg-grey2 text-grey1',
        className,
      )}
    >
      {text}
    </div>
  );
};
